import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { HttpParams, HttpClient } from '@angular/common/http';

interface Carta {
    UID: string;
    UID_RESTAURANT: string;
    name: string;
    name_ca: string;
    name_en: string;
    name_it: string;
    name_fr: string;
    name_de: string;
    subtitle: string;
    carta_subtitle: string;
    carta_style: string;
    pages: object;
    hide_footer: boolean;
    show_caption: boolean;
    show_description: boolean;
    show_enumerate_elements: boolean;
    show_enumerate_pages: boolean;
    show_logo: boolean;
    show_price: boolean;
    show_price_half: boolean;
    show_price_tapa: boolean;
    digital_app: boolean;
    tk_active: boolean;
    template_name: string;
    reference: string;
    footer: string;
    order_share: number;
}

@Injectable()
export class CartaServices {
    private firestore: any;
    //
    cartasCol: AngularFirestoreCollection<Carta>;
    cartasDoc: AngularFirestoreDocument<Carta>;
    cartas: Observable<Carta[]>;

    //create edit
    public carta_dish_prod_array_tmp = Array();
    public list_array_tmp = Array();
    public carta_section_array_complete_tmp: any;
    public carta_page_array_complete_tmp: any;
    public carta_dish_prod_array_complete_tmp: any;

    //view
    public pages_array_tmp: any;
    public carta_lang: string = 'es';
    public page_active: number = 1;
    public edit: any = false; // Marca si mostrar la parte de editar
    public edit_section: any = false; // Secciona a editar
    public edit_index: any = 0; // Indicie global de la seccion a editar
    public edit_elements_array: any;
    public edit_type: any;
    public edit_page_index: any = 0;
    public elements_array_tmp: any;
    public edit_sections: any;
    public edit_pages: any

    //
    public percent: any;

    public carta_tmp: Carta = {
        UID: '',
        UID_RESTAURANT: '',
        name: '',
        name_ca: '',
        name_en: '',
        name_it: '',
        name_fr: '',
        name_de: '',
        subtitle: '',
        carta_subtitle: '',
        carta_style: '',
        pages: {},
        hide_footer: true,
        show_caption: false,
        show_description: false,
        show_enumerate_elements: false,
        show_enumerate_pages: false,
        show_logo: false,
        show_price: false,
        show_price_half: false,
        show_price_tapa: false,
        digital_app: true,
        tk_active: false,
        template_name: '',
        reference: '',
        footer: '',
        order_share: 0,
    };

    public pagesDishesProducts: any;
    public page_active_paginator: number = 1;
    public limit_pages = 100;
    public get_dishes_products_done: boolean = false;
    public products_dishes_array_tmp: any;
    public products_dishes_array: any;
    public elements_order_show: boolean = false;
    public no_cartas: boolean = true;
    public total_cartas: number = 0;

    public valueChanges: any;
    public url_share_xxss: string = "";

    constructor(public afs: AngularFirestore,
        public globals: Globals,
        public http: HttpClient,) {
        this.firestore = firebase.firestore();
    }

    //
    getList(UID_RESTAURANT) {
        this.cartasCol = this.afs.collection('cartas', ref => ref
            .where('UID_RESTAURANT', '==', UID_RESTAURANT));
        this.cartas = this.cartasCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Carta;
                data.UID = a.payload.doc.id;
                this.no_cartas = false;
                return data;
            });
        });

        //Recuperamos el total de cartas
        this.cartas.subscribe(doc => {
            this.total_cartas = doc.length;
        });
    }

    //
    async getCartas(UID_RESTAURANT) {
        const cartasRef = this.firestore.collection('cartas');

        var cartas = [];

        await cartasRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
            .then(snapshot => {
                snapshot.forEach(doc => {

                    var carta = doc.data();
                    carta.UID = doc.id;

                    cartas.push(carta);
                });
            });
        this.total_cartas = cartas.length;
        //For para poner en activo los platos que puede ver el free.
        cartas.sort((a, b) => this.globals.nameLangSelectCarta(a).localeCompare(this.globals.nameLangSelectCarta(b)));
        cartas.forEach((value, index) => {
            value._active = true;
            if (index >= this.globals.checkLimitsByLicense('menus', 'max_menus') && this.globals.checkLimitsByLicense('menus', 'max_menus') != -1) {
                value._active = false;
            }
        });
        return cartas;
    }

    //get dishes and products
    async getPartialSelectDishProds(UID_RESTAURANT) {
        this.list_array_tmp = Array();
        //get dishes
        const dishesRef = this.firestore.collection('dish');

        await dishesRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
            .then(snapshot => {
                snapshot.forEach(doc => {

                    var dish = doc.data();
                    dish.UID = doc.id;
                    dish.type = 'dish';
                    dish.name = dish.name_es;

                    this.list_array_tmp.push(dish);
                });
            });
        //get products
        const productsRef = this.firestore.collection('products');

        await productsRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
            .then(snapshot => {
                snapshot.forEach(doc => {

                    var product = doc.data();
                    product.UID = doc.id;
                    product.type = 'product';

                    this.list_array_tmp.push(product);
                });
            });
        //order

        this.list_array_tmp.sort(function (a, b) {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
        })
    }

    getIndexOfPage() {
        var array = this.globals.objectToArray(this.carta_tmp.pages);
        this.edit_page_index = 0;
        this.edit_sections = this.globals.objectToArray(array[0].sections);
    }

    cleanEdit() {
        this.edit = false;
        this.edit_section = '';
        this.edit_index = 0;
        this.edit_elements_array = Array();
        this.edit_type = '';
    }
    //FILTER
    public filteredProductsDishes: any;
    public filteredProductsDishesActive: boolean = false;
    searchProductsDishesNode(value) {
        if (value.target.value == '' || value.target.value == undefined) {
            this.filteredProductsDishesActive = false;
        } else {
            if (value.target.value.length >= 3) {
                let limit_dishes = this.globals.checkLimitsByLicense('dishes', 'max_dishes');
                let limit_products = this.globals.checkLimitsByLicense('stock', 'ings_prods');
                //Miramos si la licencia tiene límite de stock
                if (this.globals.checkLimitsByLicense('stock', 'ings_prods') > 0) {
                    //si lo tiene lo mandamos a buscar dentro del listado reducido
                    const params = new HttpParams()
                        .set('uid', this.globals.restaurant_uid)
                        .set('filter_string', value.target.value.toLowerCase())
                        .set('limit_dishes', limit_dishes)
                        .set('limit_products', limit_products);
                    this.http.post(this.globals.analytics_path + 'filter/limited_dishes_products', params, {})
                        .subscribe(async res => {
                            this.filteredProductsDishes = res;
                            this.filteredProductsDishesActive = true;
                        });
                } else {
                    //Si no tiene límite filtramos dentro del todos los platos y productos
                    const params = new HttpParams()
                        .set('uid', this.globals.restaurant_uid)
                        .set('filter_string', value.target.value.toLowerCase());
                    this.http.post(this.globals.analytics_path + 'filter/dishes_products_combos', params, {})
                        .subscribe(async res => {
                            this.filteredProductsDishes = res;
                            this.filteredProductsDishesActive = true;
                        });
                }
            } else {
                this.filteredProductsDishesActive = false;
            }
        }
    }
    first_element: any;
    //PAGINATE
    async getPagesDishesProducts(elements_per_page) {
        this.get_dishes_products_done = false;
        this.filteredProductsDishesActive = false;
        this.limit_pages = elements_per_page;

        let limit_dishes = this.globals.checkLimitsByLicense('dishes', 'max_dishes');
        let limit_products = this.globals.checkLimitsByLicense('stock', 'ings_prods');
        //Miramos si la licencia tiene límite de stock o de platos
        if (limit_products > 0 && limit_dishes > 0) {
            //si lo tiene lo mandamos a recuperar X cantidad de productos y  X cantidad de platos
            const params = new HttpParams()
                .set('uid', this.globals.restaurant_uid)
                .set('elements_per_page', elements_per_page)
                .set('limit_dishes', limit_dishes)
                .set('limit_products', limit_products);

            await this.http.post(this.globals.analytics_path + 'paginate/limited_dishes_products', params, {})
                .subscribe(async res => {
                    this.pagesDishesProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
                    this.products_dishes_array_tmp = res['list'];
                    if (this.pagesDishesProducts != 0) {
                        this.getListDishesProductsMinMax();
                    } else {
                        this.get_dishes_products_done = true;
                    }
                });

        } else {
            //Si no tiene límite le mandamos a recuperar con el paginador
            const params = new HttpParams()
                .set('uid', this.globals.restaurant_uid)
                .set('elements_per_page', elements_per_page);
            await this.http.post(this.globals.analytics_path + 'paginate/dishes_products_combos', params, {})
                .subscribe(async res => {
                    this.pagesDishesProducts = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
                    this.products_dishes_array_tmp = res['list'];
                    if (this.pagesDishesProducts != 0) {
                        this.getListDishesProductsMinMax();
                    } else {
                        this.filteredProductsDishesActive = true;
                    }
                });
        }
    }
    getListDishesProductsMinMax() {
        this.get_dishes_products_done = true;

        //Ordenamos el array
        this.products_dishes_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));

        //Search for first element to start
        this.first_element = (this.page_active_paginator - 1) * this.limit_pages;
        //We slice the array with the first element, and the first element plus the limit to get the last index
        if (this.limit_pages > 0) {
            this.products_dishes_array = this.products_dishes_array_tmp.slice(this.first_element, this.first_element + this.limit_pages);
        } else {
            this.products_dishes_array = this.products_dishes_array_tmp;
        }
    }

    async getCartasTkActive() {
        const cartasRef = this.firestore.collection('cartas');
        var cartas = [];
        await cartasRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).where('tk_active', '==', true).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var carta = doc.data();
                    carta.UID = doc.id;
                    cartas.push(carta);
                });
            });
        return cartas;
    }
}


// WEBPACK FOOTER //
// ./src/pages/carta/services.ts